import React from "react";
import { Link } from "gatsby"
import _ from "lodash"

import { PopularSearch_Areas } from "../../../../common/constant"
import { PropertySearchUrl, getBedUrl } from "../../../../common/utils/property_utils"

const PropertyAction = ({searchParams, property_type_list}) => {
    
    var property_url = PropertySearchUrl(searchParams.department, searchParams?.search_type)

    var property_text = "Property";
    if(searchParams.department === "commercial"){
        property_text = "Commercial property";
    }

    var no_bedrooms = "";

    if(searchParams.department === "residential"){
        if(searchParams.bedrooms){
            if(parseInt(searchParams.bedrooms) === 0){
                no_bedrooms = "Studio";
            } else{
                no_bedrooms = parseInt(searchParams.bedrooms) > 1 ? searchParams.bedrooms+" bedroom" : searchParams.bedrooms+" bedroom";
            }
        }
    }

    //console.log("searchParams", searchParams)

    if(searchParams.propertyType){
        var prop_type = searchParams.propertyType;

        var filter_prop_type = searchParams.propertyType ? (property_type_list?.length > 0 && property_type_list.filter(item => item.value === searchParams.propertyType)) : "";
        if(filter_prop_type?.length > 0){
            prop_type = filter_prop_type[0].label.replace(/\//g,' and ');
        }
    }

    return (<>
        <ul>
            {PopularSearch_Areas.map((item) => {
                return(<>
                    {searchParams.bedrooms && searchParams.propertyType ?
                        <li><Link to={`${property_url}in-${item.value}/type-${searchParams.propertyType}/${getBedUrl(searchParams.bedrooms)}`}>{no_bedrooms} {prop_type.toLowerCase()} {searchParams.action} in {item.label}</Link></li>
                    :
                    searchParams.bedrooms ?
                        <li><Link to={`${property_url}in-${item.value}/${getBedUrl(searchParams.bedrooms)}`}>{no_bedrooms} {property_text.toLowerCase()} {searchParams.action} in {item.label}</Link></li>
                    :
                    searchParams.propertyType ?
                        <li><Link to={`${property_url}in-${item.value}/type-${searchParams.propertyType}/`}>{prop_type} {searchParams.action} in {item.label} </Link></li>
                    :
                        <li><Link to={`${property_url}in-${item.value}/`}>{property_text} {searchParams.action} in {item.label}</Link></li>
                    }
                    
                </>)
            })}
        </ul>
    </>)
}
export default PropertyAction;